import React, { Component } from 'react';
import { Tabs } from 'antd';

import ConsultantList from './scenes/ConsultantList/ConsultantList';
import TeamList from './scenes/TeamList/TeamList';
import ConsultantRanking from './scenes/ConsultantRanking/ConsultantRanking';
import './ConsultantPage.scss';

const TabPane = Tabs.TabPane;

export class ConsultantPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 'individual',
        }
    }

    componentDidMount() {
        const { location } = this.props;
        const { hash } = location;

        if (hash) {
            this.setState({ activeTab: hash.substring(1) })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { location } = this.props;
        const { hash } = location;

        if (hash !== prevProps.location.hash)
            this.setState({ activeTab: hash.substring(1) })
    }

    render() {
        const { history } = this.props;
        const { activeTab } = this.state;

        return (
            <div className="ConsultantPage ListPage">
            	<div className="page-header">
            		<h2>Consultants</h2>
            	</div>
            	<Tabs 
            		activeKey={activeTab}
            		type="card" 
            		tabBarGutter={5}
            		onChange={(key) => history.push(`/dashboard/admin/consultant#${key}`)}
            	>
            		<TabPane tab="Individual" key="individual">
            			<ConsultantList isActive={activeTab === 'individual'}/>
					</TabPane>
					<TabPane tab="Team" key="team">
            			<TeamList isActive={activeTab === 'team'}/>
					</TabPane>
                    <TabPane tab="Ranking" key="ranking">
                        <ConsultantRanking isActive={activeTab === 'ranking'}/>
                    </TabPane>
            	</Tabs>
			</div>
        );
    }
}

export default ConsultantPage;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ConsultantPage/ConsultantPage.js